<div class="card" id="card-config">
  <div class="head">
    <h1>Usuários</h1>
    <div class="row">
      <div class="col-md-5">
        <label class="w-100">Usuarios do Cliente
          <select class="form-control" type="number" [(ngModel)]="clientesId" (ngModelChange)="listarUsuarios()">
            <option [value]="cliente.sr_id" *ngFor="let cliente of clientes">
              {{cliente.vc_nome}}
            </option>
          </select>
        </label>
      </div>
      <div class="col-md-5">
        <label class="w-100">Pesquisar:
          <input id="searchbar" name="search" type="search" class="form-control" [(ngModel)]="pesquisa"
            (ngModelChange)="filtraUsuarios()">
        </label>
      </div>
      <div class="col-md-2 botao-cadastro">
        <div class="">
          <button *ngIf="verificarPermissao(['cadastro_usuario'])" class="btn-nav" routerLink="../usuarios/cadastro">
            <mat-icon class="material-icons-sharp">
              person_add
            </mat-icon>
            Novo usuário
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-hover">
      <thead>
        <tr>
          <th scope="col">Login</th>
          <th scope="col">Nome</th>
          <th scope="col">Telefone</th>
          <th scope="col">Grupos</th>
          <th scope="col">Status</th>
          <th scope="col"></th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr [class.red]="usuario.bl_status == 0"
          *ngFor="let usuario of filtraUsuarios() | paginate: {itemsPerPage: 10, currentPage: paginaAtual}">
          <td class="search-parameter">{{usuario.vc_login}}</td>
          <td class="search-parameter">{{usuario.vc_nome}}</td>
          <td>{{usuario.vc_telefone | mask: '+00(00) 900000000'}}</td>
          <td class="td-grupos">{{usuario.ar_grupos.join(', ')}}</td>
          <td>{{usuario.bl_status == 1 ? 'Ativo' : 'Inativo'}}</td>
          <td>
            <button *ngIf="verificarPermissao(['atualizar_usuario'])" [disabled]="usuario.bl_status == 0"
              class="btn-nav" routerLink="../usuarios/atualizar/{{usuario.sr_id}}"
              routerLinkActive="router-link-active"> <mat-icon class="material-icons-sharp">
                edit
              </mat-icon>Editar</button>
          </td>
          <td>
            <button *ngIf="verificarPermissao(['status_usuario'])" (click)="finalizar(usuario)" class="btn-nav">
              <mat-icon class="material-icons-sharp del">
                delete_forever
              </mat-icon>Ativar/Desativar</button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="lista-vazia" *ngIf="!usuarios.length">
      <p *ngIf="!load">Selecione um cliente para listar os usuários</p>
    </div>
  </div>
</div>
<div class="load" *ngIf="load">
  <mat-progress-spinner diameter=30 class="example-margin" [color]="color" [mode]="mode" [value]="value">
  </mat-progress-spinner>
</div> <pagination-controls class="pagination d-flex flex-row-reverse" (pageChange)="paginaAtual = $event"
  previousLabel="Anterior" nextLabel="Próximo"></pagination-controls>
